import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RequestSourceModal } from "./RequestSourceModal";
import { Actions as sourceActions } from "../../core/redux/ducks/source";
import {
  Box,
  Container,
  Tabs,
  Tab,
  makeStyles,
  Theme,
  createStyles,
} from "@material-ui/core";
import { InternetSources } from "./InternetSources";
import { ISource, IUserSource } from "../../core/redux/dataMap/source";
import { InternSources } from "./InternSources";
import { DBSources } from "./DBSources";
import useLanguage from "../../hooks/useLanguage";

interface ISourcesProps {}

export const Sources: React.FC<ISourcesProps> = () => {
  const [modalShow, setModalShow] = useState(false);
  const classes = useStyles();
  const sourceState = useSelector((state) => state.source);
  const {
    userSources,
    sources,
    loading,
    isAllChecked,
    isAllUserSourcesChecked,
  } = sourceState;
  const dispatch = useDispatch();
  const { language } = useLanguage();
  const { translate } = language;
  const { user } = useSelector((state) => state.user);
  const [tabIndex, setTab] = useState(1);

  const fetchSources = () => sourceActions.fetchSources(dispatch);
  const fetchUserSources = () => sourceActions.fetchUserSources(dispatch);
  const updateUserSource = (source: ISource) => {
    const userSource = userSources.find(
      (userSource) => userSource.source.id === source.id
    );
    if (userSource)
      sourceActions.updateUserSource(dispatch, source, userSource.id);
    else sourceActions.updateUserSource(dispatch, source, 0);
  };
  const toggleAllSources = () => {
    sourceActions.toggleAllSources(dispatch, isAllChecked);
  };
  const toggleAllUserSources = () => {
    sourceActions.toggleAllUserSources(dispatch, isAllUserSourcesChecked);
  };
  const toggleUserSources = (userSource: IUserSource) => {
    sourceActions.toggleUserSources(dispatch, userSource);
  };

  useEffect(() => {
    if (sources && !sources.length) fetchSources();
    if (userSources && !userSources.length) fetchUserSources();
  }, []);

  useEffect(() => {
    if (!!user?.isPremium) {
      setTab(0);
    }
  }, [user]);

  const requestSourceModal = () => {
    setModalShow(true);
  };

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Container className={classes.root}>
      <Box pt={12} width={1}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          className={classes.tabs}
        >
          {!!user?.isPremium && <Tab label="Internet" value={0} />}
          <Tab label={translate.own_archive} value={1} />
          <Tab label={translate.paid_databases} value={2} />
        </Tabs>
        {tabIndex === 0 && !!user?.isPremium && (
          <InternetSources
            sources={sources}
            userSources={userSources}
            isLoading={loading}
            isAllChecked={isAllChecked}
            isAllUserSourcesChecked={isAllUserSourcesChecked}
            requestSourceModal={requestSourceModal}
            updateUserSource={updateUserSource}
            toggleAllSources={toggleAllSources}
            toggleUserSources={toggleUserSources}
            toggleAllUserSources={toggleAllUserSources}
          />
        )}
        {tabIndex === 1 && <InternSources />}
        {tabIndex === 2 && <DBSources />}
      </Box>
      {!!user?.isPremium && (
        <RequestSourceModal
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}
    </Container>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      flexGrow: 1,
      display: "flex",
    },
    tabs: {
      borderBottom: "1px solid #ccc",
    },
  })
);
